import React from 'react';
import PropTypes from 'prop-types';
import AnonFooter from './AnonFooter';
import AuthedFooter from './AuthedFooter';
import { FooterContext } from './SMFooterContext';

import './footer.scss';

const SMFooter = ({
  isUserAuthenticated,
  lang,
  domain,
  subdomain,
  country,
  variant,
  showBillingAddress,
  isEUDC,
  isPrivateLabel,
  tld,
  url,
  onetrustBannerEnabled,
}) => {
  return (
    <FooterContext
      isUserAuthenticated={isUserAuthenticated}
      lang={lang}
      subdomain={subdomain}
      domain={domain}
      country={country}
      variant={variant}
      showBillingAddress={showBillingAddress}
      isEUDC={isEUDC}
      isPrivateLabel={isPrivateLabel}
      tld={tld}
      url={url}
      onetrustBannerEnabled={onetrustBannerEnabled}
    >
      {isUserAuthenticated ? <AuthedFooter /> : <AnonFooter />}
    </FooterContext>
  );
};

SMFooter.propTypes = {
  isUserAuthenticated: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  subdomain: PropTypes.string.isRequired,
  showBillingAddress: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'limited', 'slim']),
  isEUDC: PropTypes.bool.isRequired,
  isPrivateLabel: PropTypes.bool,
  tld: PropTypes.string.isRequired,
  url: PropTypes.string,
  onetrustBannerEnabled: PropTypes.bool.isRequired,
};

SMFooter.defaultProps = {
  showBillingAddress: false,
  isPrivateLabel: false,
  variant: 'default',
  url: null,
};

export default SMFooter;
